import { PropsWithChildren, createContext, useMemo } from 'react';

import { LANG } from '@/i18n/constants';
import { getTenantClusterByTenant } from '@/utils/tenantClusterStorage';
import { _getStorage } from '@/utils/useLocalStorage';

import type { ConfigProviderProps } from './interface';

const defaultProps: ConfigProviderProps = {
  [LANG]: 'zh-cn',
  userInfo: {},
  config: {},
  policies: [],
  backMenu: [],
  clusterList: [],
  tenantList: [],
  cluster: _getStorage('cluster', ''),
  tenant: _getStorage('tenant', ''),
  mode: _getStorage('mode', 'data-center'),
  tenantCluster: getTenantClusterByTenant(_getStorage('tenant', '')) || '',
  tenantClusters: [],
  loading: false,
  isLogin: false,
};

export const ConfigContext = createContext<ConfigProviderProps>({
  ...defaultProps,
});

export function ConfigProvider(baseProps: PropsWithChildren<ConfigProviderProps>) {
  const config = useMemo(() => ({ ...defaultProps, ...baseProps }), [baseProps]);
  return <ConfigContext.Provider value={config}>{baseProps.children}</ConfigContext.Provider>;
}

ConfigProvider.displayName = 'ConfigProvider';
